import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatNumberReturnView',
    standalone: false
})
export class FormatNumberReturnViewPipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): unknown {        
    if((value + '') === 'NaN') return "";
    else if(value === undefined || value == null || isNaN(value)) return new Intl.NumberFormat('bn-BD').format(0);
    else if(value === '') return ''
    else if(typeof value == 'string') return new Intl.NumberFormat('bn-BD').format(Math.round(parseFloat(value)))
    else if (typeof value == 'number') return new Intl.NumberFormat('bn-BD').format(Math.round(value));
  }

}
